import { useAuth } from "@/auth/use-auth";
import { getRedirectPath } from "@/lib/get-redirect-path";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/")({
  component: Root,
});

function Root() {
  const { authUser } = useAuth();
  return <Navigate to={getRedirectPath(authUser)} replace />;
}
